import { render } from "./AssignToAccount.vue?vue&type=template&id=d870c608"
import script from "./AssignToAccount.vue?vue&type=script&lang=js"
export * from "./AssignToAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__